<template>
    <div style="">

        <div v-if="couponData && couponData.discount">
            <div v-if="plain">
                <div v-if="round">
                    <!--                <div style="background-color: white; color: #EE0A24; border-radius: 10px; border: 1px solid #EE0A24">-->
                    <!--                    <span style="padding: 0px 6px;">券 ¥{{couponData.discount}}</span>-->
                    <!--                </div>-->
                    <van-tag :size="size" round color="#FFFFFF" style="padding: 1px 6px; border: 1px solid #EE0A24">
                        <div slot="default" style="background-color: white; color: #EE0A24">
                            券 ¥{{couponData.discount}}
                        </div>
                    </van-tag>
                </div>
                <div v-else>
                    <van-tag :size="size" color="#FFFFFF" style="padding: 1px 0px; border: 1px solid #EE0A24">
                        <div slot="default" style="background-color: white; color: #EE0A24">
                            <span style="padding: 2px;">券 ¥{{couponData.discount}}</span>

                            <div class="plain_no_round_left" :style="{marginTop: margin_top_px}"></div>

                            <div class="plain_no_round_right" :style="{marginTop: margin_top_px}"></div>
                        </div>
                    </van-tag>
                    <!--                <div style="background-color: white; color: #EE0A24; border-radius: 3px; border: 1px solid #EE0A24;">-->
                    <!--                    <span style="padding: 0px 5px;">券 ¥{{couponData.discount}}</span>-->

                    <!--                    <div style="width: 4px; height: 8px; border-radius: 0px 4px 4px 0px; background-color: #ffffff;-->
                    <!--                    float: left; margin-top: 5px; margin-left: -1px; border: 1px solid #EE0A24; border-left: 0px">-->

                    <!--                    </div>-->

                    <!--                    <div style="width: 4px; height: 8px; border-radius: 4px 0px 0px 4px; background-color: #ffffff;-->
                    <!--                    float: right; margin-top: 5px; margin-right: -1px; border: 1px solid #EE0A24; border-right: 0px">-->

                    <!--                    </div>-->
                    <!--                </div>-->
                </div>
            </div>
            <div v-else>
                <div v-if="round">
                    <van-tag :size="size" round color="#EE0A24" style="padding: 2px 7px; ">
                        券 ¥{{couponData.discount}}
                    </van-tag>
                </div>
                <div v-else>
                    <van-tag :size="size" color="#EE0A24" style="padding: 2px 0px">
                        <div slot="default">
                            <span style="padding: 2px;">券 ¥{{couponData.discount}}</span>

                            <div class="no_plain_no_round_left" :style="{marginTop: margin_top_px}"></div>

                            <div class="no_plain_no_round_right" :style="{marginTop: margin_top_px}">
                            </div>
                        </div>
                    </van-tag>
                </div>
            </div>
        </div>

        <div v-else>
            <van-tag style="background-color: rgba(0,0,0,0); font-size: 0px;">
                券
            </van-tag>
        </div>

    </div>
</template>

<script>
    export default {
        name: "JdCouponBar",
        props: {
            couponData: {type: Object, default: null},
            size:{type:String, default:""},//medium large
            plain: {type: Boolean, default: false},
            round: {type: Boolean, default: false},
        },
        data() {
            return {
                startTime: '',
                endTime: '',
                img:'/images/coupon.png',

                margin_top_px: "0.18rem",
                // margin_top_px: "3px",
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                // if(this.couponData && this.couponData.discount){
                //     this.startTime = this.$common.dateFmt("yyyy/MM/dd", new Date(this.couponData.getStartTime));
                //     this.endTime = this.$common.dateFmt("yyyy/MM/dd", new Date(this.couponData.getEndTime));
                // }
                if(this.size === "medium"){
                    this.margin_top_px = "4px"
                }else if(this.size === "large"){
                    this.margin_top_px = "5px"
                }
            }
        }
    }
</script>

<style scoped>
    .coupon{

    }

    .plain_no_round_left{
        width: 5px;
        height: 9px;
        border-radius: 0px 5px 5px 0px;
        background-color: #ffffff;
        float: left;
        margin-left: -1px;
        border: 1px solid #EE0A24;
        border-left: 0px
    }

    .plain_no_round_right{
        width: 5px;
        height: 9px;
        border-radius: 5px 0px 0px 5px;
        background-color: #ffffff;
        float: right;
        margin-right: -1px;
        border: 1px solid #EE0A24;
        border-right: 0px
    }

    .no_plain_no_round_left{
        width: 6px;
        height: 9px;
        border-radius: 0px 5px 5px 0px;
        background-color: #ffffff;
        float: left;
        margin-left: -1px;
    }

    .no_plain_no_round_right{
        width: 6px;
        height: 9px;
        border-radius: 5px 0px 0px 5px;
        background-color: #ffffff;
        float: right;
        margin-right: -1px;
    }

</style>